// @flow

/**
 * Module dependencies.
 */

import { colors, media } from 'client/styles';
import { compose } from 'recompose';
import { position } from 'polished';
import { translator } from 'core/utils';
import Agents from 'client/components/for-agents/agents';
import Content from 'client/components/content';
import GetInTouch from 'client/components/licensed-representatives/get-in-touch';
import Header from 'client/components/header';
import Layout from 'client/components/core/layout';
import PageContent from 'client/components/core/page-content';
import React, { Component } from 'react';
import StickyNavbarTrigger from 'client/components/core/sticky-navbar/sticky-navbar-trigger';
import Workflow from 'client/components/for-agents/workflow';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  translate: Function
};

/**
 * Content styles.
 */

const contentStyles = `padding: 0;`;

/**
 * `Overlay` component.
 */

const Overlay = styled.div`
  ${position('absolute', '0', '0', '50%', '0')}

  background-color: ${colors.white};
  display: none;

  ${media.min.md`display: block;`}
`;

/**
 * `ForAgents` component.
 */

class ForAgents extends Component {

  /**
   * Props.
   */

  props: Props;

  /**
   * Render.
   */

  render(): React$Element<*> {
    const { translate } = this.props;
    const itemsList = [
      translate('forAgents.getInTouch.list.item1'),
      translate('forAgents.getInTouch.list.item2'),
      translate('forAgents.getInTouch.list.item3'),
      translate('forAgents.getInTouch.list.item4')
    ];

    const successContent = {
      buttonThemeColor: colors.brandSecondary,
      message: translate('forAgents.getInTouch.form.success.message'),
      renderIcon: false
    };

    return (
      <PageContent background={colors.shadesOfSand2.pampasDarker}>
        <Header
          filename={'for-agents-header'}
          short
          title={translate('forAgents.title')}
        />

        <Content
          pullTop
          separator
        >
          <Agents
            icon={'currency-swaps'}
            text={translate('forAgents.currencySwaps.text')}
            title={translate('forAgents.currencySwaps.title')}
          />
        </Content>

        <Layout position={'relative'}>
          <Overlay />

          <Content
            background={colors.brown}
            pullRight
            styles={contentStyles}
          >
            <Workflow
              icon={'secure-workflow'}
              text={translate('forAgents.secureWorkflow.text')}
              title={translate('forAgents.secureWorkflow.title')}
            />
          </Content>
        </Layout>

        <Content background={colors.shadesOfSand2.pampasDarker}>
          <Agents
            icon={'trust-authenticity'}
            text={translate('forAgents.trust.text')}
            title={translate('forAgents.trust.title')}
          />
        </Content>

        <StickyNavbarTrigger />

        <GetInTouch
          backgroundColor={colors.shadesOfSand2.pampasDarker}
          backgroundImage={'building'}
          formSubmitLabel={translate('forAgents.getInTouch.form.button')}
          formTitle={translate('forAgents.getInTouch.form.title')}
          list={itemsList}
          reason={'agent_registration'}
          successContent={successContent}
          title={translate('forAgents.getInTouch.title')}
        />
      </PageContent>
    );
  }

}

/**
 * Export `ForAgents` component.
 */

export default compose(
  translator()
)(ForAgents);



// WEBPACK FOOTER //
// ../src/client/containers/for-agents/index.js